/* eslint react/no-unused-prop-types: 0 */
import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import { trackSocialShareClick } from 'lib/omniture';
import appBaseUrlSelector from 'common/selectors/appBaseUrlSelector';
import currentUrlSelector from 'common/selectors/currentUrlSelector';
import pageSelector from 'common/selectors/pageSelector';
import providerSelector from 'common/selectors/providerSelector';
import { userAuthSelector } from 'common/selectors/authenticationSelectors';
import { entitlementsTrackingSelector } from 'common/selectors/analyticsSelectors';
import { intlAppSelector, intlSelector, countrySelector, isDomesticSelector } from 'common/selectors/appSelector';
import EmailShare from './EmailShare';
import FacebookShare from './FacebookShare';
import TwitterShare from './TwitterShare';

const shareOutlets = [
    { key: 'email', Component: EmailShare },
    { key: 'facebook', Component: FacebookShare },
    { key: 'twitter', Component: TwitterShare }
];

// curry the tracking to bind to presentational click handlers
const generateClickHandler = (content, page, provider, socialPlatform, userAuth, entitlementsTracking, isDomestic) => (event) => {
    if (event.preventDefault) {
        event.preventDefault();
    }

    trackSocialShareClick(content, page, provider, socialPlatform, userAuth, entitlementsTracking, isDomestic);
};

/**
 * The pageShell provided JS provides share functionality, by binding click handlers to the rendered DOM of this components.
 * The implementation of share functionality pprevents React Synthetic Events from firing. As a result, we are maintaining
 * event listeners on the references to the DOM elements.
 *
 * Here is the external JavaScript from the pageShell: https://code.espn.com/webdev/score/blob/develop/static/js/helpers/social_clicks.js
 */
class SharePalette extends Component {
    constructor(props) {
        super(props);
        this.clickHandlers = {}; // reference to click handlers so we may unbind
        this.removeClickHandlers = this.removeClickHandlers.bind(this);
        this.setupClickHandlers = this.setupClickHandlers.bind(this);
    }

    componentDidMount() {
        this.setupClickHandlers();
    }

    componentWillReceiveProps(nextProps) {
        // update event listeners with latest data from store
        this.removeClickHandlers();
        this.setupClickHandlers(nextProps);
    }

    componentWillUnmount() {
        this.removeClickHandlers();
    }

    setupClickHandlers(props = this.props) {
        const { content, page, provider, userAuth, entitlementsTracking, isDomestic } = props;
        shareOutlets.forEach((outlet) => {
            this.clickHandlers[outlet.key] = generateClickHandler(
                content, page, provider, outlet.key, userAuth, entitlementsTracking, isDomestic
            );
            this.refs[outlet.key].addEventListener('click', this.clickHandlers[outlet.key]);
        });
    }

    removeClickHandlers() {
        Object.keys(this.clickHandlers).forEach((key) => {
            this.refs[key].removeEventListener('click', this.clickHandlers[key]);
        });
    }

    render() {
        return (
            <div className="shareMenu" style={{ display: this.props.intlApp ? 'none' : 'block' }}>
                <span className="shareMenu__toggle icon-font-after icon-share-solid-after" />
                <ul className="shareMenu__list">
                    {shareOutlets.map((outlet) => (
                        <li ref={outlet.key} key={`social-share-${outlet.key}`}>
                            <outlet.Component {...this.props} />
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
}

SharePalette.propTypes = {
    appBaseUrl: PropTypes.string,
    content: PropTypes.object,
    currentUrl: PropTypes.string,
    lang: PropTypes.string,
    country: PropTypes.string,
    page: PropTypes.object,
    provider: PropTypes.object,
    entitlementsTracking: PropTypes.object,
    userAuth: PropTypes.array,
    intlApp: PropTypes.bool,
    isDomestic: PropTypes.bool
};

const mapStateToProps = (state) => ({
    appBaseUrl: appBaseUrlSelector(state),
    currentUrl: currentUrlSelector(state),
    country: countrySelector(state),
    page: pageSelector(state),
    provider: providerSelector(state),
    userAuth: userAuthSelector(state),
    entitlementsTracking: entitlementsTrackingSelector(state),
    intlApp: intlAppSelector(state),
    lang: intlSelector(state).lang,
    isDomestic: isDomesticSelector(state)
});

export default connect(mapStateToProps)(SharePalette);



// WEBPACK FOOTER //
// ./app/common/social/SharePalette.js